import { render } from "./PlusIcon.vue?vue&type=template&id=79c3aed9&ts=true"
import script from "./PlusIcon.vue?vue&type=script&lang=ts"
export * from "./PlusIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__